import { siteInfo, aboutInfo } from '@/mocks/movies';

export default function FeaturesBanner() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          <div className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
              <i className="ri-shield-check-line text-background-50 text-xl"></i>
            </div>
            <h3 className="text-background-50 text-sm md:text-base font-semibold mb-1">完全免费</h3>
            <p className="text-background-50/70 text-xs">无需付费注册</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
              <i className="ri-4k-line text-background-50 text-xl"></i>
            </div>
            <h3 className="text-background-50 text-sm md:text-base font-semibold mb-1">高清画质</h3>
            <p className="text-background-50/70 text-xs">1080P流畅不卡</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
              <i className="ri-flashlight-line text-background-50 text-xl"></i>
            </div>
            <h3 className="text-background-50 text-sm md:text-base font-semibold mb-1">极速播放</h3>
            <p className="text-background-50/70 text-xs">多线路不缓冲</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
              <i className="ri-smartphone-line text-background-50 text-xl"></i>
            </div>
            <h3 className="text-background-50 text-sm md:text-base font-semibold mb-1">多端观看</h3>
            <p className="text-background-50/70 text-xs">手机电脑平板</p>
          </div>
        </div>
      </div>
    </section>
  );
}